import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Tooltip } from "primereact/tooltip"

import { useTranslation } from "react-i18next"
import "./styles.scss"

const CamposPersonalizadoBoardHeader = ({
  showTableHeader = false,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  addEmptyLine = () => {},
}) => {
  const { t } = useTranslation()
  return (
    <>
      <div className='p-3 campos-personalizados-board-header d-flex justify-content-between'>
        <div className='flex gap-3 align-items-center'>
          <h6>
            {t("inventario.articulos.modal.newArticle.campPersonal.header")}
          </h6>
          <Tooltip
            target='.tooltip-info'
            content={`${t(
              "inventario.articulos.modal.newArticle.campPersonal.tooltipMsg"
            )}`}
            position='bottom'
            className='tooltip-cartera-header'
          />
          <span className='tooltip-info'>
            <FontAwesomeIcon
              icon={["fal", "circle-info"]}
              size='xl'
            />
          </span>
        </div>

        <FontAwesomeIcon
          icon={["fal", "plus"]}
          className='pointer'
          size='xl'
          onClick={addEmptyLine}
        />
      </div>
      {showTableHeader && (
        <div className='p-3 campos-personalizados-board-header d-flex justify-content-between'>
          <h6 className='text-left w-50'>
            {t(
              "inventario.articulos.modal.newArticle.campPersonal.headerField"
            )}
          </h6>

          <h6 className='text-left w-50'>
            {t(
              "inventario.articulos.modal.newArticle.campPersonal.headerValue"
            )}
          </h6>
        </div>
      )}
    </>
  )
}

export default CamposPersonalizadoBoardHeader
